import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChildren, QueryList } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ToastService } from 'src/app/toast/toast.service';

import { SweetAlertService } from 'src/app/toast/sweet-alert.service';
import { BylawsService } from 'src/app/services/bylaws.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { delay, map, Observable, of } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Modal } from 'bootstrap';
import { SocietyService } from 'src/app/services/society.service';
import { AuditService } from 'src/app/services/audit.service';

export function fileValidator(
  allowedTypes: string[] = [],
  maxSizeInMB: number = 2
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

    return of(control.value).pipe(
      delay(500), // Simulate server delay
      map(file => {
        // const file = control.value;

        if (!file) return null; // No file selected

        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
        const isAllowedType = allowedTypes.includes(file.type);

        if (!isAllowedType) {
          return {
            invalidFileType: `Allowed types: ${allowedTypes.join(', ')}`
          };
        }

        if (file.size > maxSizeInBytes) {
          return {
            fileTooLarge: `File must be smaller than ${maxSizeInMB}MB`
          };
        }

        return null; // Valid
      }))
  }
}
@Component({
  selector: 'app-add-new-bylaws',
  templateUrl: './add-new-bylaws.component.html',
  styleUrls: ['./add-new-bylaws.component.scss']
})
export class AddNewBylawsComponent implements OnInit {

  isPriorApprovalDocument: boolean = true;
  isExistingBylaws: boolean = true;
  isNewBylaws: boolean = true;
  uploadedFileUrl: string = '';
  amendmentForm!: FormGroup;
  amendmentsList: any[] = []; // Stores table data:
  agree: boolean = false;
  checkboxOptions: any[] = [];
  checkboxOptionsBackup: any[] = [];
  societyDetails: any;
  deleteIndex: number | null = null;
  base64Pdf: any = this.sanitizer.bypassSecurityTrustResourceUrl('');
  previewDocument: any = null;
  ExpendeText = '';
  /** View link only after user picks a file in this session (not preloaded API docs). */
  userPickedFiles: { [key: string]: boolean } = {};
  fileInputs = [
    { label: 'Notice to members', key: 'proceedingSpecialHouseMeeting' },
    { label: 'Resolution Passed & Attendance Sheet', key: 'noticeSpecialHouseMeeting' },
    { label: 'Application by Secretary to RCS & Signed declaration A&B complied', key: 'proofAllMemberPresent' },
    { label: 'Proposed Amendments in Annotated Form', key: 'proposedAmendmentsAnnotatedForm' },
    { label: 'Copy of existing Bye Laws', key: 'certificatebyLaws' }

  ];

  // AmendmentsData: any = {
  //   "iByLawsId": 0,
  //   "iSocietyDetailsId": 0,
  //   "iSocietyUserID": 0,
  //   "isCompleted": true,
  //   "fileProceedingGHMPath": "string",
  //   "fileNameProceedingGHMPath": "string",
  //   "fileNoticeGHMPath": "string",
  //   "fileNameNoticeGHMPath": "string",
  //   "fileMemberPresentPath": "string",
  //   "fileNameMemberPresentPath": "string",
  //   "fileProposedAmmendmentPath": "string",
  //   "fileNameProposedAmmendmentPath": "string",
  //   "byLawsDetails": [
  //     {
  //       "isLiablity": 0,
  //       "sRegistrarApprovalPath": "",
  //       "sByLawsNo": "",
  //       "sExistByLawsDetail": "",
  //       "sNewByLawsDetail": "",
  //       "isActive": true,
  //       "isDisclamerAccepted": "",
  //       "sAmmendmentType": 0
  //     }
  //   ]
  // }
  AmendmentsData: any = {
    iByLawsId: 0,
    iSocietyDetailsId: 0,
    iSocietyUserID: 0,
    isCompleted: 1,

    fileProceedingGHMPath: '',
    fileNameProceedingGHMPath: '',

    fileNoticeGHMPath: '',
    fileNameNoticeGHMPath: '',

    fileMemberPresentPath: '',
    fileNameMemberPresentPath: '',

    fileProposedAmmendmentPath: '',
    fileNameProposedAmmendmentPath: '',

    certificatebyLaws: '',
    fileNamecertificatebyLaws: '',

    iUserId: 0,

    byLawsDetails: [
      {
        isLiablity: 0,

        sRegistrarApprovalPath: '',
        sRegistrarApprovalName: '',

        sRegistrarCertificatePath: '',
        sRegistrarCertificateName: '',

        sByLawsNo: '',
        sExistByLawsDetail: '',
        sNewByLawsDetail: '',

        isActive: true,
        isDisclamerAccepted: '',

        sAmmendmentType: 0,
        stotalmember: '',
        sAmmendmentTypeSubject: '',
        presentvoted: '',

        sAddress: '',

        iDivisionId: 0,
        iDistrictId: 0,
        iCircleId: 0,
        iBlockId: 0,
        iAreaOperation: 0,

        iLocalBody: '',
        iWard: '',

        delObjId: [],
        iPanchayat: [],
        iVillage: [],

        iSKindid: 0,
        iSTypeid: 0
      }
    ]
  };


  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    allowSearchFilter: true
  };
  byLawsId: any
  constructor(private auditService: AuditService, private fb: FormBuilder, private alertService: SweetAlertService, private toastService: ToastService, private sanitizer: DomSanitizer, private byLawsService: BylawsService, private router: Router, private route: ActivatedRoute, private ngxUiLoaderService: NgxUiLoaderService, private societyService: SocietyService) {
    this.amendmentForm = this.fb.group({
      proceedingSpecialHouseMeeting: [null, this.fileRequiredValidator()],
      registrarCertificate: [null],
      sAmmendmentTypeSubject: [''],
      noticeSpecialHouseMeeting: [null, this.fileRequiredValidator()],
      proofAllMemberPresent: [null, this.fileRequiredValidator()],
      proposedAmendmentsAnnotatedForm: [null, this.fileRequiredValidator()],
      certificatebyLaws: [null, this.fileRequiredValidator()],
      amendmentType: [''],
      stotalmember: [''],
      presentvoted: [''],
      liabilities: [''],
      priorApprovalRegistrar: [null],
      // bylawsNumber: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_]*$'), Validators.maxLength(1200)]],
      bylawsNumber: [''],
      iSKindid: [''],
      iSTypeid: [''],
      existingBylawsDetails: [''],
      newBylawsDetails: [''],
      amendments: this.fb.array([]),
      checkboxes: this.fb.array([]),

      // Address Change fields
      iAreaOperation: [''],
      address: [''],
      iDistrictId: [''],
      iCircleid: [''],
      iBlockid: [''],
      iSubCircleid: [''],
      iDivisionId: [''],
      iLocalBody: [''],
      iWard: [''],
      iPanchayat: [],  // for multi-select
      iVillage: [],
      sPincode: []
    });
    this.getDisclaimer();
    this.getAmendmentType();
    let society: any = sessionStorage.getItem('societyDetail');
    this.societyDetails = JSON.parse(society);
  }
  fileRequiredValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      return control.value?.path ? null : { required: true };
    };
  }
  objectiveList: any[] = [];
  allObjectiveList: any[] = [];
  @ViewChildren('fileInputRef') fileInputsRef!: QueryList<ElementRef>;
  ngOnInit(): void {
    this.getAllData('All')
    this.route.queryParams.subscribe(params => {
      this.byLawsId = params['byLawsId'];
      if (this.byLawsId) {
        this.getApplicationDetail(this.byLawsId)
      } else {
        // this.getMemberList()
      }
    });
    this.getDropdownData();
    this.updateFilteredSocietyTypes();
  }
  getAllData(action: any): void {
    this.ngxUiLoaderService.start();

    this.societyService.getSocietyTabsData('All', 0).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();

        if (response?.status === 200 && action === 'All') {
          const data = response?.data;

          // this.societyDetails = data?.showSocietyDetails || {};

          // if (data?.societyAreaOperation?.length > 0) {
          //   this.areaOperationList = data.societyAreaOperation;
          // }

          // Patch form (uncomment if needed)
          /*
          this.societyDetailForm.patchValue({
            userName: this.societyDetails?.userName,
            address: this.societyDetails?.address
          });
          */

          if (data?.societyObjects) {
            this.objectiveList = data?.societyObjects || [];
            this.allObjectiveList = data?.societyObjects || [];


            // this.firstnext = this.objectiveList.length > 0;

            //   if(!this.byLawsId){

            // this.societyMemberList = data?.societyMember || [];
            //   this.societyMemberList.forEach((item: any) => {
            //     if (item.file && item.fileName) {
            //       let file = this.base64ToFile(item.file, item.fileName);
            //       this.memberForm.patchValue({
            //         sUploadAadharCardPath: file
            //       });

            //       setTimeout(() => {
            //         const dataTransfer = new DataTransfer();
            //         dataTransfer.items.add(file);

            //         const fileInput = document.getElementById('formFile') as HTMLInputElement;
            //         fileInput.files = dataTransfer.files;
            //       }, 1000)

            //     }
            //   });
            //   }

          }
        }
      },

      error: (error: any) => {
        this.ngxUiLoaderService.stop();
        this.toastService.showError(error?.message || 'Something went wrong');
      }
    });
  }
  triggerFileInput(index: number) {
    const input = this.fileInputsRef.toArray()[index];
    if (input) {
      input.nativeElement.click();
    }
  }
  societyKindList: any[] = [];
  societyTypeList: any[] = [];


  getApplicationDetail(byLawsId: any) {

    let obj = {
      iByLawsId: byLawsId,
      iByLawsDetailId: byLawsId
    }

    this.byLawsService.getByLaws(byLawsId).subscribe((res: any) => {

      if (res?.status == 200 && res?.data) {
        // this.aplicationDetailList= res?.data

        this.loadAmendmentData(res?.data)
        //       const amendmentsData:any =    this.aplicationDetailList.amendments;


        // Ensure amendmentsList exists
        // this.amendmentsList =  [];

        // Loop through and push formatted entries
        // amendmentsData.forEach((item:any) => {
        //   const newEntry = {
        //     amendmentType: item.amendmentType,
        //     resolutionNo: item.resolutionNo?.trim() || '',
        //     resolutionDate: item.resolutionDate,
        //     addedOn: new Date()
        //   };

        // this.amendmentsList.push(newEntry);
        // });

        // Save to localStorage
        localStorage.setItem("amendmentsList", JSON.stringify(this.amendmentsList));
        // this.bylawsList =    this.aplicationDetailList.by
        // this.uploadedFiles =    this.aplicationDetailList;
        // this.prefillAmendmentForm(  this.aplicationDetailList)
        //  this.prefillFiles(  this.aplicationDetailList)
        // let data=this.aplicationDetailList.byLawsDetailsResponse
        // const nameData = data.find((x: any) => x.sAmmendmentType == 1);
        // const areaData = data.find((x: any) => x.sAmmendmentType == 4);
        // const addressData = data.find((x: any) => x.sAmmendmentType == 5);


        // const amendmentType2 = data.filter((x: any) => x.sAmmendmentType == 2  && !x.dObjectId);
        // if(amendmentType2 && amendmentType2.length>0){

        // amendmentType2.map((item: any) => {
        // const newObjectives = item.sNewByLawsDetail
        //       // ? item.sNewByLawsDetail.split('|').map((x: string) => x.trim())
        //       // : [];

        //  const payload = {
        //         action: null,
        //         iSocietyObjid: 0, // ✅ new record
        //         sSocietyObjDes: newObjectives,
        //         objectiveName: null,
        //         iSocietyDetailsId: this.societyDetails?.iSocietyDetailsId,
        //         iSocietyUserId: this.societyDetails?.iSocietyUserId
        //       };
        // setTimeout(()=>{
        //      this.objectiveList.push(payload);
        // },2000)


        //     })
        //this.bylawsList = [...this.bylawsList, ...formattedList];
        // }
        // const amendment = data.filter((x: any) =>!x.dObjectId);
        // const formattedList = amendment.map((item: any) => {
        //   return {
        //     type: item?.sAmmendmentType,

        //     existingDetails: item.sExistByLawsDetail
        //       ? item.sExistByLawsDetail.split('|').map((x: string, i: number) => `${i + 1}. ${x.trim()}`)
        //       : [],

        //     proposedChange: item.sNewByLawsDetail
        //       ? [item.sNewByLawsDetail]
        //       : [],

        //     purposesChange: item.reason
        //       ? [item.reason]
        //       : [],

        //     nocFile: null,

        //     // ✅ IMPORTANT: handle delete case
        //     dObjectId: item.dObjectId
        //       ? [item.dObjectId.toString()]
        //       : null
        //   };
        // });
        // this.bylawsList = [...this.bylawsList, ...formattedList];

        // this.societyMemberList =  this.aplicationDetailList.memberList
      }

    }, (res) => {
      if (res.status != 200) {


      }
    })


  }
  selectedAmendment: any = {};
  editIndex: number = -1;

  viewDetails(item: any) {
    this.selectedAmendment = item;
  }
  filteredSocietyTypeList: any[] = [];
  creditSocietyTypeNames = [
    'Miscellaneous Credit Cooperative Society',
    'Primary Agricultural Credit Society (PACS)',
    'Urban Cooperative Bank (UCB)',
    'Farmers Service Societies (FSS)',
    'Large Area Multipurpose Society (LAMPS)',
    'Credit & Thrift Society'
  ];
  onSocietyKindChange(event: any) {
    const selectedKindId = event.target ? event.target.value : event;

    this.amendmentForm.get('iSKindid')?.setValue(selectedKindId);

    this.updateFilteredSocietyTypes();

    this.amendmentForm.get('iSTypeid')?.setValue('');
  }

  updateFilteredSocietyTypes() {
    const selectedKindId = this.amendmentForm.get('iSKindid')?.value;

    const selectedKind = this.societyKindList.find(
      (x: any) => x.id == selectedKindId
    );

    if (selectedKind?.name === 'Credit') {
      this.filteredSocietyTypeList = this.societyTypeList.filter(
        (type: any) =>
          this.creditSocietyTypeNames.includes(type.name)
      );
    } else {
      this.filteredSocietyTypeList = this.societyTypeList.filter(
        (type: any) =>
          !this.creditSocietyTypeNames.includes(type.name)
      );
    }

    const selectedTypeId = this.amendmentForm.get('iSTypeid')?.value;

    if (
      selectedTypeId &&
      this.filteredSocietyTypeList.some((x: any) => x.id == selectedTypeId)
    ) {
      this.amendmentForm.get('iSTypeid')?.setValue(selectedTypeId);
    } else {
      this.amendmentForm.get('iSTypeid')?.setValue('');
    }
  }



  showLiabilityColumn(): boolean {
    return this.amendmentsList?.some((x: any) => x.liabilities == 1);
  }

  showPriorDocColumn(): boolean {
    return this.amendmentsList?.some((x: any) => x.priorApprovalRegistrar?.path);
  }

  showRegistrarCertificateColumn(): boolean {
    return this.amendmentsList?.some((x: any) =>
      this.isNameOrAddressAmendment(x.sAmmendmentTypeSubject) &&
      this.hasRegistrarCertificate(x)
    );
  }

  isNameOrAddressAmendment(subjectId: any): boolean {
    const name = (this.typeName(subjectId) || '').trim();
    return name === 'Name' || name === 'Address';
  }

  hasRegistrarCertificate(item: any): boolean {
    const cert = item?.registrarCertificate;
    return !!(cert?.path || cert?.content);
  }

  registrarCertificateLabel(item: any): string {
    const raw = item?.registrarCertificate?.path || '';
    if (!raw) {
      return 'NA';
    }
    const segments = raw.split(/[/\\]/);
    return segments[segments.length - 1] || raw;
  }

  mapRegistrarCertificateFromApi(item: any): { path: string; content: string } | null {
    const name =
      item?.registrarCertificateName ||
      item?.sRegistrarCertificateName ||
      '';
    const content =
      item?.registrarCertificatePath ||
      item?.sRegistrarCertificatePath ||
      '';
    if (!name && !content) {
      return null;
    }
    return { path: name || 'Registration Certificate.pdf', content };
  }

  loadAmendmentData(data: any) {

    // ✅ Patch main fields
    this.amendmentForm.patchValue({
      sAmmendmentTypeSubject: null, // if needed global
    });

    // ✅ Store main object
    this.AmendmentsData.iByLawsId = data.iByLawsId;
    this.AmendmentsData.iSocietyDetailsId = data.iSocietyDetailsId;
    this.AmendmentsData.iSocietyUserID = data.iSocietyUserID;

    // ✅ Handle file names (ONLY display, not file input)
    // this.fileData = {
    //   proceeding: data.fileNameProceedingGHMPath,
    //   notice: data.fileNameNoticeGHMPath,
    //   member: data.fileNameMemberPresentPath,
    //   proposed: data.fileNameProposedAmmendmentPath,
    //   certificate: data.fileNamecertificatebyLaws
    // };

    // ✅ Load FormArray
    this.setByLawsDetails(data.byLawsDetails);

    //   let base64String =data.sProceedingGHMPath;
    // let file = this.base64ToFile(data.sProceedingGHMPath,  data.fileNameNoticeGHMPath);
    //   // ✅ Patch file controls (only for validation/display)
    //      setTimeout(() => {
    //                   const dataTransfer = new DataTransfer();
    //                   dataTransfer.items.add(file);

    //                   const fileInput = document.getElementById('proceedingSpecialHouseMeeting') as HTMLInputElement;
    //                   fileInput.files = dataTransfer.files;
    //                 }, 1000)

    this.amendmentForm.patchValue({
      proceedingSpecialHouseMeeting: {
        content: data.sProceedingGHMPath || '',
        path: data.fileNameProceedingGHMPath || ''
      },

      noticeSpecialHouseMeeting: {
        content: data.sNoticeGHMPath || '',
        path: data.fileNameNoticeGHMPath || ''
      },

      proofAllMemberPresent: {
        content: data.sMemberPresentPath || '',
        path: data.fileNameMemberPresentPath || ''
      },

      proposedAmendmentsAnnotatedForm: {
        content: data.sProposedAmmendmentPath || '',
        path: data.fileNameProposedAmmendmentPath || ''
      },

      certificatebyLaws: {
        content: data.certificatebyLaws || '',
        path: data.fileNamecertificatebyLaws || ''
      }
    });

  }
  base64ToFile(base64: string, fileName: string): File {

    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }
  setByLawsDetails(details: any[]) {
    // const formArray = this.amendmentForm.get('amendments') as FormArray;
    // formArray.clear();
    let formArray: any[] = []
    details.forEach(item => {
      formArray.push(this.createAmendmentGroup(item));
    });
    this.amendmentsList = formArray
  }
  createAmendmentGroup(item?: any) {
    // return this.fb.group({
    //   liabilities: [item?.isLiablity ?? 0],

    //   priorApprovalRegistrar: [item?.sRegistrarApprovalName
    //     ? { path: item.sRegistrarApprovalName, content: item.sRegistrarApprovalPath }
    //     : null
    //   ],

    //   registrarCertificate: [item?.registrarCertificateName
    //     ? { path: item.registrarCertificateName, content: item.registrarCertificatePath }
    //     : null
    //   ],

    //   bylawsNumber: [item?.sByLawsNo || ''],
    //   existingBylawsDetails: [item?.sExistByLawsDetail || ''],
    //   newBylawsDetails: [item?.sNewByLawsDetail || ''],

    //   amendmentType: [item?.sAmmendmentType || ''],
    //   sAmmendmentTypeSubject: [Number(item?.sAmmendmentTypeSubject) || ''],

    //   stotalmember: [item?.stotalmember || ''],
    //   presentvoted: [item?.presentvoted || ''],

    //   delObjId: [item?.delObjId || 0]
    // });

    return {
      liabilities: item?.isLiablity ?? 0,

      priorApprovalRegistrar: item?.sRegistrarApprovalName
        ? { path: item.sRegistrarApprovalName, content: item.sRegistrarApprovalPath }
        : null
      ,

      registrarCertificate: this.mapRegistrarCertificateFromApi(item),

      bylawsNumber: item?.sByLawsNo || '',
      existingBylawsDetails: item?.sExistByLawsDetail || '',
      newBylawsDetails: item?.sNewByLawsDetail || '',

      amendmentType: item?.sAmmendmentType || '',
      sAmmendmentTypeSubject: Number(item?.sAmmendmentTypeSubject) || '',

      stotalmember: item?.stotalmember || '',
      presentvoted: item?.presentvoted || '',

      delObjId: item?.delObjId || 0
    };
  }
  get checkboxes() {
    return this.amendmentForm.get('checkboxes') as FormArray;
  }

  allCheckboxesRequired(): any {
    return (formArray: FormArray): { [key: string]: boolean } | null => {
      const selectedCheckboxes = formArray.controls.filter(control => control.value);
      if (selectedCheckboxes.length === this.checkboxOptions.length) {
        return null;
      } else {
        return { allRequired: true };
      }
    };
  }

  addCheckbox(option: any): void {
    option.forEach((element: any) => {
      const control = this.fb.control(false);
      this.checkboxes.push(control);

    });

  }

  get amendments(): FormArray {
    return this.amendmentForm.get('amendments') as FormArray;
  }
  getDisclaimer() {
    this.byLawsService.getDisclaimer().subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.checkboxOptions = res.data;
        this.addCheckbox(this.checkboxOptions)
        this.checkboxOptionsBackup = JSON.parse(JSON.stringify(res.data));
        this.onLiabilitiesChange(0)
      }


      //this.toastService.showSuccess(response.message);
    },
      (error: any) => {
        //this.toastService.showError(error.message);
      }
    );
  }

  addAmendment() {
    const formValue = this.amendmentForm.value;
    const amendmentData: any = {
      bylawsNumber: this.amendmentForm.value.bylawsNumber?.trim(),
      existingBylawsDetails: this.amendmentForm.getRawValue().existingBylawsDetails?.trim(),
      liabilities: this.amendmentForm.value?.liabilities?this.amendmentForm.value?.liabilities?.trim():'',
      newBylawsDetails: this.amendmentForm.value.newBylawsDetails?.trim(),
      priorApprovalRegistrar: this.amendmentForm.value.priorApprovalRegistrar,
      amendmentType: this.amendmentForm.value.amendmentType,
      registrarCertificate: this.amendmentForm.value.registrarCertificate,
      sAmmendmentTypeSubject: this.amendmentForm.value.sAmmendmentTypeSubject,
      stotalmember: this.amendmentForm.value.stotalmember,
      presentvoted: this.amendmentForm.value.presentvoted,
      iSKindid: formValue.iSKindid,
      iSTypeid: formValue.iSTypeid,
      delObjId: [],
      address: formValue.address,
      iDivisionId: formValue.iDivisionId,
      iDistrictId: formValue.iDistrictId,
      iCircleid: formValue.iCircleid,
      iBlockid: formValue.iBlockid,
      iAreaOperation: formValue.iAreaOperation,
      iLocalBody: formValue.iLocalBody,
      iWard: formValue.iWard,
      iPanchayat: formValue.iPanchayat,
      iVillage: formValue.iVillage,
      sPincode: formValue.sPincode
    };
    // if (this.amendmentForm.get('sAmmendmentTypeSubject')?.value == 9 && this.amendmentForm.get('amendmentType')?.value == 3) {
    if (this.amendmentForm.get('sAmmendmentTypeSubject')?.value == 9) {

      let objectives = this.objectiveList.map((i, index) => index + 1 + '. ' + i.sSocietyObjDes)
      this.amendmentForm.get('newBylawsDetails')?.setValue(objectives.join(','))
      amendmentData.delObjId = this.deletedObjective

    }
    if (this.amendmentForm.get('sAmmendmentTypeSubject')?.value == 7) {
      amendmentData.newBylawsDetails = this.buildFullAddress()
    }

    if (
      amendmentData.bylawsNumber &&

      amendmentData.amendmentType
    ) {



      if (formValue.sAmmendmentTypeSubject == 8) {
        if (!formValue.iSKindid || formValue.iSKindid == 0) {
          this.toastService.showError('Please select Society Kind.');
          return;
        }

        if (!formValue.iSTypeid || formValue.iSTypeid == 0) {
          this.toastService.showError('Please select Society Type.');
          return;
        }
      }

      const totalMembers = Number(amendmentData.stotalmember);
      const presentVoted = Number(amendmentData.presentvoted);

      if (!totalMembers || !presentVoted) {
        this.toastService.showError(
          'Please enter Total Members and Members Present & Voted.'
        );
        return;
      }

      if (presentVoted > totalMembers) {
        this.toastService.showError(
          'Members Present & Voted cannot be greater than Total Members.'
        );
        return;
      }

      let quorum = 0;

      if (totalMembers <= 500) {
        quorum = Math.min(Math.ceil(totalMembers / 3), 50);
      } else {
        quorum = Math.min(Math.ceil(totalMembers / 3), 100);
      }

      if (presentVoted < quorum) {
        this.toastService.showError(
          `Quorum not complete as per Rule 30. Minimum required Members P&V is ${quorum}.`
        );
        return;
      }
      if (this.editIndex >= 0) {

        const rowIndex = this.editIndex;

        const updatedRow = {
          bylawsNumber: amendmentData?.bylawsNumber ?? '',
          existingBylawsDetails: amendmentData?.existingBylawsDetails ?? '',
          liabilities: amendmentData?.liabilities ?? '',
          newBylawsDetails: amendmentData?.newBylawsDetails ?? '',
          priorApprovalRegistrar: amendmentData?.priorApprovalRegistrar ?? '',
          amendmentType: amendmentData?.amendmentType ?? '',
          registrarCertificate: amendmentData?.registrarCertificate ?? '',
          sAmmendmentTypeSubject: amendmentData?.sAmmendmentTypeSubject ?? '',
          stotalmember: amendmentData?.stotalmember ?? '',
          presentvoted: amendmentData?.presentvoted ?? '',
          iSKindid: amendmentData?.iSKindid ?? '',
          iSTypeid: amendmentData?.iSTypeid ?? '',
          delObjId: amendmentData?.delObjId ?? [],
          address: amendmentData?.address ?? '',
          iDivisionId: amendmentData?.iDivisionId ?? '0',
          iDistrictId: amendmentData?.iDistrictId ?? '0',
          iCircleid: amendmentData?.iCircleid ?? '0',
          iBlockid: amendmentData?.iBlockid ?? '0',
          iAreaOperation: amendmentData?.iAreaOperation ?? '0',
          iLocalBody: amendmentData?.iLocalBody ?? '0',
          iWard: amendmentData?.iWard ?? '0',
          iPanchayat: amendmentData?.iPanchayat ?? [],
          iVillage: amendmentData?.iVillage ?? [],
          sPincode: amendmentData?.sPincode ?? ''
        };

        // update row
        this.amendmentsList[this.editIndex] = { ...updatedRow };

        this.amendments.setControl(
          this.editIndex,
          this.fb.group({ ...updatedRow })
        );
        this.checkboxOptions = JSON.parse(JSON.stringify(this.checkboxOptionsBackup))
        this.removeAllCheckboxes();
        this.addCheckbox(this.checkboxOptions);
        this.amendmentForm.patchValue({
          bylawsNumber: '',
          existingBylawsDetails: '',
          liabilities: '',
          newBylawsDetails: '',
          priorApprovalRegistrar: '',
          amendmentType: '',
          registrarCertificate: '',
          sAmmendmentTypeSubject: '',
          stotalmember: '',
          presentvoted: '',
          address: '',
          iSKindid: '',
          iSTypeid: '',
          iDivisionId: '0',
          iDistrictId: '0',
          iCircleid: '0',
          iBlockid: '0',
          iAreaOperation: '0',
          iLocalBody: '0',
          iWard: '0',
          iPanchayat: [],
          iVillage: [],
          sPincode: ''


        });

        this.amendmentForm.controls['liabilities'].clearValidators()
        this.amendmentForm.controls['bylawsNumber'].clearValidators()
        this.amendmentForm.controls['existingBylawsDetails'].clearValidators()
        this.amendmentForm.controls['newBylawsDetails'].clearValidators()
        this.amendmentForm.controls['checkboxes'].clearValidators()
        this.amendmentForm.controls['priorApprovalRegistrar'].clearValidators()
        this.amendmentForm.controls['certificatebyLaws'].clearValidators()
        this.amendmentForm.controls['registrarCertificate'].clearValidators()

        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['sAmmendmentTypeSubject'].clearValidators();
        this.amendmentForm.controls['presentvoted'].clearValidators();
        this.amendmentForm.controls['stotalmember'].clearValidators()
        this.amendmentForm.controls['iSTypeid'].clearValidators()

        this.amendmentForm.controls['iSKindid'].clearValidators()

        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
        this.amendmentForm.controls['sAmmendmentTypeSubject'].updateValueAndValidity();
        this.amendmentForm.controls['presentvoted'].updateValueAndValidity();
        this.amendmentForm.controls['stotalmember'].updateValueAndValidity()

        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()
        this.amendmentForm.controls['iSTypeid'].updateValueAndValidity()

        this.amendmentForm.controls['iSKindid'].updateValueAndValidity()
        this.amendmentForm.controls['liabilities'].updateValueAndValidity()
        this.amendmentForm.controls['bylawsNumber'].updateValueAndValidity()
        this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity()
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity()
        this.amendmentForm.controls['checkboxes'].updateValueAndValidity()
        this.amendmentForm.controls['priorApprovalRegistrar'].updateValueAndValidity()
        this.amendmentForm.controls['certificatebyLaws'].updateValueAndValidity()
        this.resetAddressFields();
        this.editIndex = -1;
        this.selectedAmendment = null;



        return;
      }



      else {

        this.amendmentsList.push(amendmentData);
        this.amendments.push(this.fb.group(amendmentData));
        this.checkboxOptions = JSON.parse(JSON.stringify(this.checkboxOptionsBackup))
        this.removeAllCheckboxes();
        this.addCheckbox(this.checkboxOptions);
        this.amendmentForm.patchValue({
          bylawsNumber: '',
          existingBylawsDetails: '',
          liabilities: '',
          newBylawsDetails: '',
          priorApprovalRegistrar: '',
          amendmentType: '',
          registrarCertificate: '',
          sAmmendmentTypeSubject: '',
          stotalmember: '',
          presentvoted: '',
          address: '',
          iSKindid: '',
          iSTypeid: '',
          iDivisionId: '0',
          iDistrictId: '0',
          iCircleid: '0',
          iBlockid: '0',
          iAreaOperation: '0',
          iLocalBody: '0',
          iWard: '0',
          iPanchayat: [],
          iVillage: [],
          sPincode: ''


        });

        this.amendmentForm.controls['liabilities'].clearValidators()
        this.amendmentForm.controls['bylawsNumber'].clearValidators()
        this.amendmentForm.controls['existingBylawsDetails'].clearValidators()
        this.amendmentForm.controls['newBylawsDetails'].clearValidators()
        this.amendmentForm.controls['checkboxes'].clearValidators()
        this.amendmentForm.controls['priorApprovalRegistrar'].clearValidators()
        this.amendmentForm.controls['certificatebyLaws'].clearValidators()
        this.amendmentForm.controls['registrarCertificate'].clearValidators()

        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['sAmmendmentTypeSubject'].clearValidators();
        this.amendmentForm.controls['presentvoted'].clearValidators();
        this.amendmentForm.controls['stotalmember'].clearValidators()
        this.amendmentForm.controls['iSTypeid'].clearValidators()

        this.amendmentForm.controls['iSKindid'].clearValidators()

        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
        this.amendmentForm.controls['sAmmendmentTypeSubject'].updateValueAndValidity();
        this.amendmentForm.controls['presentvoted'].updateValueAndValidity();
        this.amendmentForm.controls['stotalmember'].updateValueAndValidity()

        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()
        this.amendmentForm.controls['iSTypeid'].updateValueAndValidity()

        this.amendmentForm.controls['iSKindid'].updateValueAndValidity()
        this.amendmentForm.controls['liabilities'].updateValueAndValidity()
        this.amendmentForm.controls['bylawsNumber'].updateValueAndValidity()
        this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity()
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity()
        this.amendmentForm.controls['checkboxes'].updateValueAndValidity()
        this.amendmentForm.controls['priorApprovalRegistrar'].updateValueAndValidity()
        this.amendmentForm.controls['certificatebyLaws'].updateValueAndValidity()
        this.resetAddressFields();

      }
    } else {
      this.toastService.showError('Please fill in all required fields before adding an amendment.');
    }
  }
  editAmendment(item: any, index: number) {

    this.editIndex = index;
    this.selectedAmendment = item;
    this.removeAllCheckboxes();

    this.checkboxOptions = JSON.parse(
      JSON.stringify(this.checkboxOptionsBackup)
    );

    const selectedIds = (item?.checkboxes || []).map(
      (y: any) => y.iDisclaimerId
    );

    const checkboxArray = this.amendmentForm.get('checkboxes') as FormArray;

    this.checkboxOptions.forEach((x: any) => {
      checkboxArray.push(
        this.fb.control(selectedIds.includes(x.iDisclaimerId))
      );
    });
    const priorApprovalRegistrar =
      item?.priorApprovalRegistrar
        ? item.priorApprovalRegistrar
        : null;

    const registrarCertificate =
      item?.registrarCertificate
        ? item.registrarCertificate
        : null;

    //-------------------------------------------------
    // Patch Form
    //-------------------------------------------------
    const ammendmentId = Number(item?.amendmentType) || 0;
    const allTypes = this.AllAmendmentType || [];
    if (ammendmentId == 1) {
      this.AmendmentType = allTypes.filter(
        (i: any) => Number(i.id) === 9 && Number(i.type) === 2
      );
      this.isExistingBylaws = false;
      this.isNewBylaws = true;
    } else if (ammendmentId == 2) {
      this.AmendmentType = allTypes.filter(
        (i: any) =>
          [6, 7, 8, 10].includes(Number(i.id)) &&
          Number(i.type) === 2
      );
      this.isExistingBylaws = false;
      this.isNewBylaws = true;
    } else if (ammendmentId) {
      this.AmendmentType = allTypes.filter(
        (i: any) => Number(i.id) === 9 && Number(i.type) === 2
      );
      this.isExistingBylaws = false;
      this.isNewBylaws = false;
    }

    this.amendmentForm.patchValue({

      bylawsNumber: item?.bylawsNumber ?? '',
      existingBylawsDetails: item?.existingBylawsDetails ?? '',
      liabilities: item?.liabilities ?? '',
      newBylawsDetails: item?.newBylawsDetails ?? '',

      priorApprovalRegistrar: priorApprovalRegistrar,
      registrarCertificate: registrarCertificate,

      amendmentType: item?.amendmentType ?? '',
      sAmmendmentTypeSubject: item?.sAmmendmentTypeSubject ?? '',
      stotalmember: item?.stotalmember ?? '',
      presentvoted: item?.presentvoted ?? '',

      iSKindid: item?.iSKindid ?? '',
      iSTypeid: item?.iSTypeid ?? '',

      address: item?.address ?? '',
      iDivisionId: item?.iDivisionId ?? '0',
      iDistrictId: item?.iDistrictId ?? '0',
      iCircleid: item?.iCircleid ?? '0',
      iBlockid: item?.iBlockid ?? '0',
      iAreaOperation: item?.iAreaOperation ?? '0',
      iLocalBody: item?.iLocalBody ?? '0',
      iWard: item?.iWard ?? '0',
      iPanchayat: item?.iPanchayat ?? [],
      iVillage: item?.iVillage ?? [],
      sPincode: item?.sPincode ?? ''

    });


    if (item?.iSKindid) {
      this.updateFilteredSocietyTypes();
    }

    if (item?.iAreaOperation) {
      this.selectedAoP = item.iAreaOperation;
    }

    this.onLiabilitiesChange(0);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  buildFullAddress(): string {
    const form = this.amendmentForm;

    const address = form.get('address')?.value || '';
    const pincode = form.get('sPincode')?.value || '';

    const districtName =
      this.districtList.find(x => x.id == form.get('iDistrictId')?.value)?.name || '';

    const divisionName =
      this.divisionList.find(x => x.id == form.get('iDivisionId')?.value)?.name || '';

    const circleName =
      this.circleList.find(x => x.id == form.get('iCircleid')?.value)?.name || '';

    const blockName =
      this.blockList.find(x => x.id == form.get('iBlockid')?.value)?.name || '';

    const localBodyName =
      this.localBodyList.find(x => x.id == form.get('iLocalBody')?.value)?.name || '';

    const wardName =
      this.wardList.find(x => x.id == form.get('iWard')?.value)?.name || '';

    const panchayatNames = (form.get('iPanchayat')?.value || '')
      .map((x: any) => x.name)
      .join(', ');

    const villageNames = (form.get('iVillage')?.value || '')
      ;

    const selectedAoP = form.get('iAreaOperation')?.value;

    let areaPart = '';

    if (selectedAoP == 7) {
      areaPart = [localBodyName, wardName].filter(Boolean).join(', ');
    } else if (selectedAoP == 8) {
      areaPart = [blockName, panchayatNames, villageNames].filter(Boolean).join(', ');
    } else {
      areaPart = [
        circleName,
        blockName,
        localBodyName,
        wardName,
        panchayatNames,
        villageNames
      ].filter(Boolean).join(', ');
    }

    return [
      address,
      areaPart,
      districtName,
      'Himachal Pradesh',
      pincode
    ]
      .filter(Boolean)
      .join(', ');
  }
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  confirmDelete() {
    this.removeAmendment(this.deleteIndex);
  }
  removeAmendment(index: number | null) {
    if (index !== null) {

      this.amendmentsList.splice(index, 1);
      this.amendments.removeAt(index);
      this.deleteIndex = null;
    }
  }

  validateNumber(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const numericText = pastedText.replace(/\D/g, '');

    const inputField = event.target as HTMLInputElement;
    inputField.value = numericText;

    // Update the form control value manually
    this.amendmentForm.controls['bylawsNumber'].setValue(numericText);
  }

  validateAlphanumeric(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey || event.altKey || event.key.length !== 1) {
      return;
    }
    if (!/^[a-zA-Z0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  validateAlphanumericPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const alphanumericText = pastedText.replace(/[^a-zA-Z0-9]/g, '').slice(0, 8);

    const inputField = event.target as HTMLInputElement;
    inputField.value = alphanumericText;
    this.amendmentForm.controls['bylawsNumber'].setValue(alphanumericText);
  }

  onAmmendmentTypeChange(event: Event): void {
    const ammendmentId = Number((event.target as HTMLSelectElement).value);
    // if (ammendmentId == 1) {
    //   this.AmendmentType = this.AllAmendmentType.filter((i: any) => i.id == 2 || i.id == 3 || i.id == 3)
    // } else if (ammendmentId == 2) {
    //   this.AmendmentType = this.AllAmendmentType.filter((i: any) => i.id == 1 || i.id == 5 || i.id == 6)
    // } else {
    //   this.AmendmentType = this.AllAmendmentType.filter((i: any) => i.id == 2 || i.id == 3)
    // }

    const allTypes = this.AllAmendmentType || [];
    if (ammendmentId == 1) {
      this.AmendmentType = allTypes.filter(
        (i: any) => Number(i.id) === 9 && Number(i.type) === 2
      );
    } else if (ammendmentId == 2) {
      this.AmendmentType = allTypes.filter(
        (i: any) =>
          [6, 7, 8, 10].includes(Number(i.id)) &&
          Number(i.type) === 2
      );
    } else {
      this.AmendmentType = allTypes.filter(
        (i: any) => Number(i.id) === 9 && Number(i.type) === 2
      );
    }
    // Existing Bye-laws Details UI is hidden; do not require that field
    if (ammendmentId === 1) {
      this.isExistingBylaws = false;
      this.isNewBylaws = true;
      this.amendmentForm.get('newBylawsDetails')?.setValidators([Validators.required]);
      this.amendmentForm.get('existingBylawsDetails')?.clearValidators();
    } else if (ammendmentId === 2) {
      this.isExistingBylaws = false;
      this.isNewBylaws = true;
      this.amendmentForm.get('newBylawsDetails')?.setValidators([Validators.required]);
      this.amendmentForm.get('existingBylawsDetails')?.clearValidators();
    } else {
      this.isExistingBylaws = false;
      this.isNewBylaws = false;
      this.amendmentForm.get('newBylawsDetails')?.removeValidators([Validators.required]);
      this.amendmentForm.get('existingBylawsDetails')?.clearValidators();

    }
    this.amendmentForm.controls['newBylawsDetails'].setValue('');
    this.amendmentForm.controls['newBylawsDetails'].setValue('');
    this.amendmentForm.controls['bylawsNumber'].setValue('');
    // this.amendmentForm.controls['liabilities'].setValue('');
    this.amendmentForm.controls['priorApprovalRegistrar'].setValue('');
    this.amendmentForm.controls['registrarCertificate'].setValue('');
    this.amendmentForm.controls['presentvoted'].setValue('');
    this.amendmentForm.controls['stotalmember'].setValue('');

    // this.amendmentForm.controls['liabilities'].setValidators([Validators.required]);
    this.amendmentForm.controls['bylawsNumber'].setValidators([Validators.required]);
    this.amendmentForm.controls['checkboxes'].setValidators([this.allCheckboxesRequired()]);
    //  this.amendmentForm.controls['registrarCertificate'].setValidators([Validators.required]);
    this.amendmentForm.controls['presentvoted'].setValidators([Validators.required]);
    this.amendmentForm.controls['stotalmember'].setValidators([Validators.required]);
    this.amendmentForm.controls['bylawsNumber'].setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]);
    // this.amendmentForm.controls['liabilities'].updateValueAndValidity()
    this.amendmentForm.controls['bylawsNumber'].updateValueAndValidity()
    this.amendmentForm.controls['checkboxes'].updateValueAndValidity()
    this.amendmentForm.get('newBylawsDetails')?.updateValueAndValidity()
    this.amendmentForm.get('existingBylawsDetails')?.updateValueAndValidity();
    this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
    this.amendmentForm.controls['presentvoted'].updateValueAndValidity();
    this.amendmentForm.controls['stotalmember'].updateValueAndValidity();

    if (!ammendmentId) {
      this.amendmentForm.controls['liabilities'].clearValidators()
      this.amendmentForm.controls['bylawsNumber'].clearValidators()
      this.amendmentForm.controls['existingBylawsDetails'].clearValidators()
      this.amendmentForm.controls['newBylawsDetails'].clearValidators()
      this.amendmentForm.controls['checkboxes'].clearValidators()
      this.amendmentForm.controls['priorApprovalRegistrar'].clearValidators()
      this.amendmentForm.controls['certificatebyLaws'].clearValidators()
      this.amendmentForm.controls['registrarCertificate'].clearValidators()

      this.amendmentForm.controls['registrarCertificate'].clearValidators();
      this.amendmentForm.controls['sAmmendmentTypeSubject'].clearValidators();
      this.amendmentForm.controls['presentvoted'].clearValidators();
      this.amendmentForm.controls['stotalmember'].clearValidators()

      this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
      this.amendmentForm.controls['sAmmendmentTypeSubject'].updateValueAndValidity();
      this.amendmentForm.controls['presentvoted'].updateValueAndValidity();
      this.amendmentForm.controls['stotalmember'].updateValueAndValidity()

      this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()

      this.amendmentForm.controls['liabilities'].updateValueAndValidity()
      this.amendmentForm.controls['bylawsNumber'].updateValueAndValidity()
      this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity()
      this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity()
      this.amendmentForm.controls['checkboxes'].updateValueAndValidity()
      this.amendmentForm.controls['priorApprovalRegistrar'].updateValueAndValidity()
      this.amendmentForm.controls['certificatebyLaws'].updateValueAndValidity()

    }
  }
  onLiabilitiesChange(value: any): void {
    // const liabilitiesId = Number((event.target as HTMLSelectElement).value);
    const liabilitiesId = Number(value);
    if (liabilitiesId === 1) {
      this.isPriorApprovalDocument = true;
      this.checkboxOptions = JSON.parse(JSON.stringify(this.checkboxOptionsBackup))
      this.removeAllCheckboxes();
      this.addCheckbox(this.checkboxOptions);
      this.amendmentForm.controls['priorApprovalRegistrar'].setValue(null);
      this.amendmentForm.controls['priorApprovalRegistrar'].setValidators([Validators.required]);
      this.amendmentForm.controls['priorApprovalRegistrar'].updateValueAndValidity()

    } else {
      this.isPriorApprovalDocument = false;
      this.checkboxOptions = JSON.parse(JSON.stringify(this.checkboxOptionsBackup.slice(0, 2)))
      this.removeAllCheckboxes();
      this.addCheckbox(this.checkboxOptions);
      this.amendmentForm.controls['priorApprovalRegistrar'].setValue(null);
      this.amendmentForm.controls['priorApprovalRegistrar'].clearValidators();
      this.amendmentForm.controls['priorApprovalRegistrar'].updateValueAndValidity()

    }

  }
  removeAllCheckboxes() {
    while (this.checkboxes.length) {
      this.checkboxes.removeAt(0);
    }
  }


  convertToBase64(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    let base64String = "";
    reader.onload = () => {
      base64String = reader.result as string;
    };


    return base64String;
  }
  AmendmentType: any;
  AllAmendmentType: any;
  getAmendmentType(): void {
    this.byLawsService.Amendsmenttypes().subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.AllAmendmentType = response.data.filter(
            (item: any) => item.type === 2
          );

          this.AmendmentType = response.data.filter(
            (item: any) => item.type === 2
          );


        }
      },
      error: (err) => {
        console.error('Failed to fetch amendment types', err);
      }
    });
  }
  selectedAmendmentType: any = '';
  selectedAmendmentName: string = '';

  onAmendmentTypeChange(event: any): void {
    this.selectedAmendmentType = event.target.value;
    this.isNewBylaws = true;
    // Existing Bye-laws Details field is hidden in the form
    this.isExistingBylaws = false;
    this.resetAddressFields()
    // let exist = this.amendmentsList.find((i) => i?.sAmmendmentTypeSubject == this.selectedAmendmentType);
    // if (exist) {
    //   this.toastService.showError(
    //     'This Type Of Amendment Already Added!'
    //   );

    //   event.target.value = '';
    //   return
    // }

    const restrictedTypes = [6, 7];

    let exist = this.amendmentsList.find(
      (i) =>
        i?.sAmmendmentTypeSubject == this.selectedAmendmentType &&
        restrictedTypes.includes(+this.selectedAmendmentType)
    );
    if (exist) {
      this.toastService.showError('This amendment can be added only once.');
      event.target.value = '';
      return;
    }
    const selected = this.AmendmentType?.find((a: any) => a.id == this.selectedAmendmentType);

    if (selected) {
      this.selectedAmendmentName = selected.name;
      this.amendmentForm.controls['existingBylawsDetails'].setValue('');
      if (this.selectedAmendmentName === 'Name') {

        this.onLiabilitiesChange(0)


        this.amendmentForm.controls['existingBylawsDetails'].setValue(this.societyDetails?.sSocietyName);
        this.amendmentForm.controls['existingBylawsDetails'].disable();
        this.amendmentForm.controls['registrarCertificate'].setValue(null);
        this.amendmentForm.controls['registrarCertificate'].setValidators([Validators.required]);
        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()


      } else if (this.selectedAmendmentName === 'Address') {
        this.isNewBylaws = false;
        this.onLiabilitiesChange(0)
        this.setAddressValidators();
        this.societyDetails?.sAddress1
        this.amendmentForm.controls['existingBylawsDetails'].setValue(this.societyDetails?.sAddress1);
        // this.amendmentForm.controls['existingBylawsDetails'].setValue(this.societyDetails?.sSocietyNamel);
        this.amendmentForm.controls['existingBylawsDetails'].disable();

        this.amendmentForm.controls['newBylawsDetails'].clearValidators();
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity()


      }
      else if (this.selectedAmendmentName == 'Kind/Type') {
        this.isNewBylaws = false;
        this.onLiabilitiesChange(0)
        this.setkindandtypeValidators();
        const societyKindId = Number(this.societyDetails?.iSKindid);

        let societyKindName =
          societyKindId === 3
            ? 'Credit'
            : societyKindId === 4
              ? 'Non Credit'
              : '';

        this.amendmentForm.get('existingBylawsDetails')?.setValue(societyKindName);
        this.amendmentForm.get('existingBylawsDetails')?.disable();

        this.amendmentForm.controls['newBylawsDetails'].clearValidators();
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity()


      }
      else if (this.selectedAmendmentType == 9) {

        if (this.amendmentForm.controls['amendmentType'].value == 1) {
          this.isNewBylaws = true
          this.amendmentForm.controls['newBylawsDetails'].setValidators(Validators.required);
        } else {
          this.isNewBylaws = false
          this.amendmentForm.controls['newBylawsDetails'].clearValidators();
        }
        this.isExistingBylaws = false;
        // Do not prefill all society bylaws into Existing Bye-laws Details
        // let objectives = this.allObjectiveList.map((i, index) => index + 1 + '. ' + i.sSocietyObjDes)
        // this.amendmentForm.controls['existingBylawsDetails'].setValue(objectives.join(','));
        // this.amendmentForm.controls['existingBylawsDetails'].disable();
        this.amendmentForm.controls['existingBylawsDetails'].setValue('');
        this.amendmentForm.controls['existingBylawsDetails'].clearValidators();
        this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity();
        this.amendmentForm.controls['registrarCertificate'].setValue(null);
        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity();
        this.onLiabilitiesChange(0)
      }
      else if (this.selectedAmendmentType == 10) {
        this.isNewBylaws = false;
        this.isExistingBylaws = false
        this.onLiabilitiesChange(1)
        // this.isExistingBylaws =fal
        // this.isNewBylaws
        this.amendmentForm.controls['existingBylawsDetails'].setValue('');
        this.amendmentForm.controls['newBylawsDetails'].setValue('');
        this.amendmentForm.controls['existingBylawsDetails'].clearValidators();
        this.amendmentForm.controls['newBylawsDetails'].clearValidators();
        // this.amendmentForm.controls['existingBylawsDetails'].disable();
        this.amendmentForm.controls['registrarCertificate'].setValue(null);
        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()
        this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity();
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity();
      } else if (this.selectedAmendmentType == 9) {


        this.isExistingBylaws = false;
        this.isNewBylaws = true
        this.amendmentForm.controls['newBylawsDetails'].setValidators(Validators.required);

        this.amendmentForm.controls['existingBylawsDetails'].clearValidators();


        this.amendmentForm.controls['registrarCertificate'].setValue(null);
        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity();
        this.amendmentForm.controls['existingBylawsDetails'].updateValueAndValidity();
        this.amendmentForm.controls['newBylawsDetails'].updateValueAndValidity();
        this.onLiabilitiesChange(0)

      } else {
        this.onLiabilitiesChange(0)
        this.amendmentForm.controls['existingBylawsDetails'].enable();
        this.amendmentForm.controls['registrarCertificate'].setValue(null);
        this.amendmentForm.controls['registrarCertificate'].clearValidators();
        this.amendmentForm.controls['registrarCertificate'].updateValueAndValidity()
      }

    }

  }
  setkindandtypeValidators() {
    this.amendmentForm.get('iSKindid')?.setValidators([Validators.required]);
    this.amendmentForm.get('iSTypeid')?.setValidators([Validators.required]);

    this.amendmentForm.get('iSKindid')?.updateValueAndValidity();
    this.amendmentForm.get('iSTypeid')?.updateValueAndValidity();
  }
  typeName(id: any) {
    return this.AllAmendmentType?.find((a: any) => a.id == id)?.name ?? '';
  }

  getAmendmentActionLabel(type: any): string {
    const t = Number(type);
    if (t === 1) {
      return 'Add';
    }
    if (t === 2) {
      return 'Change';
    }
    if (t === 3) {
      return 'Remove';
    }
    return 'NA';
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  canShowFileView(key: string): boolean {
    return !!(
      this.userPickedFiles[key] &&
      this.amendmentForm.get(key)?.value?.content
    );
  }

  async onFileSelected(event: any, fileInput: string) {
    const file = event.target.files[0];

    if (file) {
      let fileName = file.name;
      let fileExtension = this.getFileExtension(file.name);

      if (
        // fileExtension !== 'jpg' &&
        // fileExtension !== 'jpeg' &&
        // fileExtension !== 'png' &&
        fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: pdf.'
        );
        event.target.value = '';
        this.amendmentForm.get(fileInput)?.setValue(null);
        this.userPickedFiles[fileInput] = false;
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        );
        event.target.value = '';
        this.amendmentForm.get(fileInput)?.setValue(null);
        this.userPickedFiles[fileInput] = false;
        return;
      }


      let blob = new Blob([file], { type: file.type })
      let content = await this.blobToBase64(blob);
      let obj = {
        path: fileName,
        content: content
      }

      this.amendmentForm.get(fileInput)?.setValue(obj);
      this.userPickedFiles[fileInput] = true;
    } else {
      this.amendmentForm.get(fileInput)?.setValue(null);
      this.userPickedFiles[fileInput] = false;
    }
    this.amendmentForm.get(fileInput)?.updateValueAndValidity();
  }


  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // When the reader finishes, resolve the promise with the result (Base64 string)
      reader.onloadend = () => {
        resolve(reader.result as string);  // Base64 string is available here
      };

      // Handle any errors
      reader.onerror = (error) => {
        reject(error);
      };

      // Read the Blob as a Data URL (Base64)
      reader.readAsDataURL(blob);
    });
  }
  preview(document: any) {
    if (!document?.content) {
      this.toastService.showError('No file available to view.');
      return;
    }
    this.previewDocument = document || null;
    const name = String(document?.path || '').toLowerCase();
    let mime = 'application/pdf';
    if (name.endsWith('.png')) {
      mime = 'image/png';
    } else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
      mime = 'image/jpeg';
    }
    try {
      const blob = this.base64ToBlob(document.content, mime);
      this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(
        URL.createObjectURL(blob)
      );
    } catch {
      this.toastService.showError('Unable to open the selected file.');
    }
  }

  downloadDocument(document: any) {
    if (!document?.content) {
      this.toastService.showError('Document not available for download.');
      return;
    }
    try {
      const blob = this.base64ToBlob(document.content, 'application/pdf');
      const url = URL.createObjectURL(blob);
      const link = window.document.createElement('a');
      const rawName = document.path || 'document.pdf';
      const segments = String(rawName).split(/[/\\]/);
      const fileName = segments[segments.length - 1] || 'document.pdf';
      link.href = url;
      link.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      this.toastService.showError('Unable to download document.');
    }
  }

  base64ToBlob(base64: any, contentType = "",
    sliceSize = 512) {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length;
      offset += sliceSize) {
      const slice = byteCharacters.slice(
        offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  close() {
    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl('');
    this.previewDocument = null;
  }


  // submit() {
  //   this.AmendmentsData.iByLawsId = this.byLawsId ? Number(this.byLawsId) : '',
  //     this.AmendmentsData.iSocietyDetailsId = this.societyDetails?.iSocietyDetailsId,
  //     this.AmendmentsData.iSocietyUserID = this.societyDetails?.iSocietyUserId,
  //     this.AmendmentsData.fileProceedingGHMPath = this.amendmentForm.value.proceedingSpecialHouseMeeting.content
  //   this.AmendmentsData.fileNameProceedingGHMPath = this.amendmentForm.value.proceedingSpecialHouseMeeting.path
  //   this.AmendmentsData.fileNoticeGHMPath = this.amendmentForm.value.noticeSpecialHouseMeeting.content
  //   this.AmendmentsData.fileNameNoticeGHMPath = this.amendmentForm.value.noticeSpecialHouseMeeting.path
  //   this.AmendmentsData.fileMemberPresentPath = this.amendmentForm.value.proofAllMemberPresent.content
  //   this.AmendmentsData.fileNameMemberPresentPath = this.amendmentForm.value.proofAllMemberPresent.path
  //   this.AmendmentsData.fileProposedAmmendmentPath = this.amendmentForm.value.proofAllMemberPresent.content
  //   this.AmendmentsData.fileNameProposedAmmendmentPath = this.amendmentForm.value.proposedAmendmentsAnnotatedForm.path
  //   this.AmendmentsData.certificatebyLaws = this.amendmentForm.value.certificatebyLaws.content
  //   this.AmendmentsData.fileNamecertificatebyLaws = this.amendmentForm.value.certificatebyLaws.path
  //   let byLawsDetails = this.amendmentsList.map(res => {

  //     return {
  //       "isLiablity": res?.liabilities ? res?.liabilities : 0,
  //       "sRegistrarApprovalPath": res?.priorApprovalRegistrar?.content ? res?.priorApprovalRegistrar?.content : '',
  //       "sRegistrarApprovalName": res?.priorApprovalRegistrar?.path ? res?.priorApprovalRegistrar?.path : '',
  //       "sByLawsNo": res?.bylawsNumber,
  //       "sExistByLawsDetail": res?.existingBylawsDetails ? res?.existingBylawsDetails : '',
  //       "sNewByLawsDetail": res?.newBylawsDetails ? res?.newBylawsDetails : '',
  //       "isActive": false,
  //       "isDisclamerAccepted": (res?.liabilities == '1') ? '1,2,3,4' : '3,4',
  //       "sAmmendmentType": res?.amendmentType,

  //       "sRegistrarCertificatePath": res?.registrarCertificate?.content ? res?.registrarCertificate?.content : '',
  //       "sRegistrarCertificateName": res.registrarCertificate?.path ? res.registrarCertificate?.path : '',
  //       sAmmendmentTypeSubject: res?.sAmmendmentTypeSubject ? res?.sAmmendmentTypeSubject.toString() : '',
  //       stotalmember: res?.stotalmember,
  //       presentvoted: res?.presentvoted,
  //       delObjId: res?.delObjId,

  //       "iSKindid": Number(res?.iSKindid) || 0,
  //       "iSTypeid": Number(res?.iSTypeid) || 0,
  //       "iDivisionId": Number(res?.iDivisionId) || 0,
  //       "iDistrictId": Number(res?.iDistrictId) || 0,
  //       "iCircleId": Number(res?.iCircleid) || 0,
  //       "iBlockId": Number(res?.iBlockid) || 0,
  //       "iAreaOperation": Number(res?.iAreaOperation) || 0,

  //       // 🔹 Local Body & Ward (STRING SAFE)
  //       "iLocalBody": res?.iLocalBody ? String(res.iLocalBody) : '0',
  //       "iWard": res?.iWard ? String(res.iWard) : '0',

  //       // ✅ For multi-select (IMPORTANT)
  //       "iPanchayat": res?.iPanchayat || [],

  //       "iVillage": res.iVillage || [],
  //     }
  //   })
  //   this.AmendmentsData.byLawsDetails = byLawsDetails


  //   this.ngxUiLoaderService.start();


  //   this.byLawsService.applyAmendsments(this.AmendmentsData).subscribe((res: any) => {


  //     if (res?.status == 200) {
  //       this.toastService.showSuccess(res?.message)
  //       this.router.navigate([`/bylaws`]);
  //     }
  //     this.ngxUiLoaderService.stop();
  //   }, (res) => {
  //     this.ngxUiLoaderService.stop();
  //     if (res.status != 200) {

  //       this.toastService.showError('Something went wrong')
  //     }
  //   })
  // }
  submit() {

    this.AmendmentsData.iByLawsId = this.byLawsId
      ? Number(this.byLawsId)
      : 0;

    this.AmendmentsData.iSocietyDetailsId =
      this.societyDetails?.iSocietyDetailsId || 0;

    this.AmendmentsData.iSocietyUserID =
      this.societyDetails?.iSocietyUserId || 0;

    // Final submit (confirmation Yes): 1 = submitted (clears SendBack 7). Avoid 0 — SP may skip/wipe details.
    this.AmendmentsData.isCompleted = 1;
    this.AmendmentsData.IsCompleted = 1;

    this.AmendmentsData.fileProceedingGHMPath =
      this.amendmentForm.value.proceedingSpecialHouseMeeting?.content || '';

    this.AmendmentsData.fileNameProceedingGHMPath =
      this.amendmentForm.value.proceedingSpecialHouseMeeting?.path || '';

    this.AmendmentsData.fileNoticeGHMPath =
      this.amendmentForm.value.noticeSpecialHouseMeeting?.content || '';

    this.AmendmentsData.fileNameNoticeGHMPath =
      this.amendmentForm.value.noticeSpecialHouseMeeting?.path || '';

    this.AmendmentsData.fileMemberPresentPath =
      this.amendmentForm.value.proofAllMemberPresent?.content || '';

    this.AmendmentsData.fileNameMemberPresentPath =
      this.amendmentForm.value.proofAllMemberPresent?.path || '';

    this.AmendmentsData.fileProposedAmmendmentPath =
      this.amendmentForm.value.proposedAmendmentsAnnotatedForm?.content || '';

    this.AmendmentsData.fileNameProposedAmmendmentPath =
      this.amendmentForm.value.proposedAmendmentsAnnotatedForm?.path || '';

    this.AmendmentsData.certificatebyLaws =
      this.amendmentForm.value.certificatebyLaws?.content || '';

    this.AmendmentsData.fileNamecertificatebyLaws =
      this.amendmentForm.value.certificatebyLaws?.path || '';

    const byLawsDetails = this.amendmentsList.map((res: any) => {
      return {
        isLiablity: Number(res?.liabilities) || 0,

        sRegistrarApprovalPath:
          res?.priorApprovalRegistrar?.content || '',

        sRegistrarApprovalName:
          res?.priorApprovalRegistrar?.path || '',

        sRegistrarCertificatePath:
          res?.registrarCertificate?.content || '',

        sRegistrarCertificateName:
          res?.registrarCertificate?.path || '',

        sByLawsNo: res?.bylawsNumber || '',

        sExistByLawsDetail:
          res?.existingBylawsDetails || '',

        sNewByLawsDetail:
          res?.newBylawsDetails || '',

        isActive: true,

        isDisclamerAccepted:
          Number(res?.liabilities) === 1
            ? '1,2,3,4'
            : '3,4',

        sAmmendmentType:
          Number(res?.amendmentType) === 1 ||
          Number(res?.amendmentType) === 2 ||
          Number(res?.amendmentType) === 3
            ? Number(res?.amendmentType)
            : 0,

        stotalmember:
          res?.stotalmember?.toString() || '',

        sAmmendmentTypeSubject:
          res?.sAmmendmentTypeSubject?.toString() || '',

        presentvoted:
          res?.presentvoted?.toString() || '',

        sAddress:
          res?.address || '',

        iDivisionId:
          Number(res?.iDivisionId) || 0,

        iDistrictId:
          Number(res?.iDistrictId) || 0,

        iCircleId:
          Number(res?.iCircleid) || 0,

        iBlockId:
          Number(res?.iBlockid) || 0,

        iAreaOperation:
          Number(res?.iAreaOperation) || 0,

        iLocalBody:
          res?.iLocalBody
            ? String(res.iLocalBody)
            : '',

        iWard:
          res?.iWard
            ? String(res.iWard)
            : '',

        delObjId:
          res?.delObjId || [],

        iPanchayat:
          res?.iPanchayat || [],

        iVillage:
          res?.iVillage || [],

        iSKindid:
          Number(res?.iSKindid) || 0,

        iSTypeid:
          Number(res?.iSTypeid) || 0
      };
    });

    this.AmendmentsData.byLawsDetails = byLawsDetails;


    this.ngxUiLoaderService.start();

    this.byLawsService
      .applyAmendsments(this.AmendmentsData)
      .subscribe(
        (res: any) => {
          this.ngxUiLoaderService.stop();

          if (res?.status == 200) {
            this.toastService.showSuccess(res?.message);
            this.router.navigate(['/bylaws']);
          } else {
            this.toastService.showError('Something went wrong');
          }
        },
        (error) => {
          this.ngxUiLoaderService.stop();
          this.toastService.showError('Something went wrong');
        }
      );
  }

  viewMore(event: any) {
    this.ExpendeText = event
    this.openModal('readMoreModal')
  }
  hideViewMore() {
    this.ExpendeText = ''
    this.hideModal('readMoreModal')
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  deletedObjective: any[] = []
  async deleteObj(id: any, object: any) {
    const confirmed = await this.alertService.confirmAlert(
      'Warning',
      'Are you sure you want to delete this information? This action cannot be undone.',
      'Ok',
      'Cancel'
    );

    if (confirmed) {
      const index = this.objectiveList.findIndex(
        (obj) => obj.iSocietyObjid === id || obj.sSocietyObjDes === object.sSocietyObjDes
      );



      this.objectiveList.splice(index, 1);
      this.deletedObjective.push(id)


      if (object.iSocietyObjid) {
        const payload = {
          type: 2,
          existingDetails: this.objectiveList
            .filter(obj => obj.iSocietyObjid)
            .map((obj, index) => `${index + 1}. ${obj.sSocietyObjDes}`),
          proposedChange: [],
          purposesChange: ['DeleteObjective'],
          nocFile: null,

          dObjectId: [object.iSocietyObjid.toString()]
        };

        // this.amendmentsList.push(payload);
      }
    }











  }
  selectedAoP: any;
  // Dynamic AoP change
  onChangeAoP() {
    this.selectedAoP = this.amendmentForm.get('iAreaOperation')?.value;
    this.resetAddressFields();
    this.setAddressValidators();
    // this.getDistrict(0)
  }

  // onAmendmentTypeChange() {
  //   this.setAddressValidators();
  // }

  districtList: any[] = [];
  divisionList: any[] = [];
  operationAreaList: any[] = [];
  subcircleList: any[] = [];
  blockList: any[] = [];
  circleList: any[] = [];
  subdivisionList: any[] = [];
  localBodyList: any[] = [];
  wardList: any[] = [];
  panchayatList: any[] = [];
  villageList: any[] = [];

  resetAddressFields() {
    this.localBodyList = [];
    this.wardList = [];
    this.panchayatList = [];
    this.villageList = [];
    this.circleList = [];
    this.blockList = [];

    const controls = ['address', 'iDivisionId', 'iDistrictId', 'iLocalBody', 'iWard', 'iPanchayat', 'iVillage', 'iCircleid', 'iBlockid', 'sPincode'];
    controls.forEach(c => {
      const control = this.amendmentForm.get(c);
      if (control) {
        if (['iPanchayat', 'iVillage'].includes(c)) {
          control.setValue([]);
        } else {
          control.setValue('0');
        }
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }
  setAddressValidators() {
    const selectedAoP = this.amendmentForm.get('iAreaOperation')?.value;
    const address = this.amendmentForm.get('address');
    const sAmmendmentType = this.amendmentForm.get('sAmmendmentType')?.value;

    const iLocalBody = this.amendmentForm.get('iLocalBody');
    const iDivisionId = this.amendmentForm.get('iDivisionId');
    const iWard = this.amendmentForm.get('iWard');
    const iPanchayat = this.amendmentForm.get('iPanchayat');
    const iVillage = this.amendmentForm.get('iVillage');
    const iCircle = this.amendmentForm.get('iCircleid');
    const iBlock = this.amendmentForm.get('iBlockid');
    const sPincode = this.amendmentForm.get('sPincode');
    sPincode?.setValidators([
      Validators.required,
      Validators.minLength(6),
      Validators.pattern(/^[1-9][0-9]{5}$/),
    ])
    iDivisionId?.setValidators([
      Validators.required
    ])
    address?.setValidators([Validators.required]);
    if (sAmmendmentType == 5) {
      if (selectedAoP == 7) {
        // Urban / Municipal Area
        iLocalBody?.setValidators([Validators.required]);
        iWard?.setValidators([Validators.required]);
        iPanchayat?.clearValidators();
        iVillage?.clearValidators();
        iCircle?.setValidators([Validators.required]);
        iBlock?.clearValidators();
      } else if (selectedAoP == 8) {
        // Rural / Panchayat Area
        iPanchayat?.setValidators([Validators.required]);
        iVillage?.setValidators([Validators.required]);
        iLocalBody?.clearValidators();
        iWard?.clearValidators();
        iCircle?.clearValidators();
        iBlock?.setValidators([Validators.required]);
      } else {
        // Other AoP
        iLocalBody?.setValidators([Validators.required]);
        iWard?.setValidators([Validators.required]);
        iPanchayat?.setValidators([Validators.required]);
        iVillage?.setValidators([Validators.required]);
        iCircle?.setValidators([Validators.required]);
        iBlock?.setValidators([Validators.required]);
      }
    } else {
      // No Amendment Type = 5, clear all
      iLocalBody?.clearValidators();
      iWard?.clearValidators();
      iPanchayat?.clearValidators();
      iVillage?.clearValidators();
      iCircle?.clearValidators();
      iBlock?.clearValidators();
    }

    // Update validity
    iLocalBody?.updateValueAndValidity();
    iWard?.updateValueAndValidity();
    iPanchayat?.updateValueAndValidity();
    iVillage?.updateValueAndValidity();
    iCircle?.updateValueAndValidity();
    iBlock?.updateValueAndValidity();
  }

  getDistrict(event: any) {
    this.districtList = [];
    this.amendmentForm.controls['iDistrictId'].setValue(0);
    this.circleList = [];
    this.amendmentForm.controls['iCircleid'].setValue(0);
    this.blockList = [];
    this.amendmentForm.controls['iBlockid'].setValue(0);
    this.subcircleList = [];
    this.amendmentForm.controls['iSubCircleid'].setValue(0);
    this.panchayatList = [];
    this.amendmentForm.controls['iPanchayat'].setValue([]);
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);
    this.localBodyList = [];
    this.amendmentForm.controls['iLocalBody'].setValue('0');
    this.wardList = [];
    this.amendmentForm.controls['iWard'].setValue('0');

    const divID = event.target.value || 0;
    this.societyService.getDistrict(divID).subscribe({
      next: (response) => {
        if (response.status === 200) this.districtList = response.data;
      },
      error: (err) => { }
    });
  }

  getCircle(event: any) {
    this.circleList = [];
    this.amendmentForm.controls['iCircleid'].setValue(0);
    this.blockList = [];
    this.amendmentForm.controls['iBlockid'].setValue(0);
    this.subcircleList = [];
    this.amendmentForm.controls['iSubCircleid'].setValue(0);
    this.panchayatList = [];
    this.amendmentForm.controls['iPanchayat'].setValue([]);
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);
    this.wardList = [];
    this.amendmentForm.controls['iWard'].setValue('0');

    const districtId = event.target.value || 0;
    this.societyService.getCircle(districtId).subscribe({
      next: (response) => {
        if (response.status === 200) this.circleList = response.data;
      },
      error: (err) => { }
    });

    this.getLocalBody(event);
  }

  getBlock(event: any) {
    this.blockList = [];
    this.amendmentForm.controls['iBlockid'].setValue(0);
    this.subcircleList = [];
    this.amendmentForm.controls['iSubCircleid'].setValue(0);
    this.panchayatList = [];
    this.amendmentForm.controls['iPanchayat'].setValue([]);
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);

    this.societyService.getBlock(event.target.value).subscribe({
      next: (response) => {
        if (response.status === 200) this.blockList = response.data;
      },
      error: (err) => { }
    });
  }

  getSubCircle(event: any) {
    this.subcircleList = [];
    this.amendmentForm.controls['iSubCircleid'].setValue(0);
    this.panchayatList = [];
    this.amendmentForm.controls['iPanchayat'].setValue([]);
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);

    this.societyService.getsubcircle(event.target.value).subscribe({
      next: (response) => {
        if (response.status === 200) this.subcircleList = response.data;
      },
      error: (err) => { }
    });
  }

  getPanchayat(event: any, punch?: any) {
    if (this.selectedAoP === 7) return;

    this.panchayatList = [];
    this.amendmentForm.controls['iPanchayat'].setValue([]);
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);

    this.societyService.getPanchayat(event.target.value).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.panchayatList = response.data;

          if (punch) {
            const selectedPanchayats = this.panchayatList.filter(p => punch.includes(p.id));
            this.amendmentForm.patchValue({ iPanchayat: selectedPanchayats });
          }
        }
      },
      error: (err) => { }
    });
  }

  getVillage(event: any, action?: any) {
    this.villageList = [];
    this.amendmentForm.controls['iVillage'].setValue([]);
    let selected: any = action ? event.target?.value.split(',') : this.amendmentForm.get('iPanchayat')?.value;

    if (selected && selected.length > 0) {
      const selectedIds = action ? selected : selected.map((p: any) => p.id);

      this.societyService.getVillage(selectedIds.join(',')).subscribe({
        next: (response) => {
          if (response.status === 200) {
            this.villageList = response.data;

            if (action) {
              const selectedVillages = this.villageList.filter(p => selected.includes(p.id));
              this.amendmentForm.patchValue({ iVillage: selectedVillages });
            }
          }
        },
        error: (err) => { }
      });
    }
  }
  getLocalBody(event: any) {
    this.localBodyList = [];
    this.amendmentForm.controls['iLocalBody'].setValue('0');
    this.wardList = [];
    this.amendmentForm.controls['iWard'].setValue('0');

    const circleId = event.target.value || 0;

    this.societyService.getLocalBody(circleId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.localBodyList = response.data;
          // Optional: prefill if editing
          // if (this.amendmentDetails?.iLocalBody) {
          //   this.amendmentForm.controls['iLocalBody'].setValue(this.amendmentDetails.iLocalBody);
          // }
        } else {
          this.localBodyList = [];
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.localBodyList = [];
        this.toastService.showError(error.message);
      },
    });
  }

  getWards(event: any) {
    this.wardList = [];
    this.amendmentForm.controls['iWard'].setValue('0');

    const localBodyId = event.target.value || 0;

    this.societyService.getWards(localBodyId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.wardList = response.data;
          // Optional: prefill if editing
          // if (this.amendmentDetails?.iWard) {
          //   this.amendmentForm.controls['iWard'].setValue(this.amendmentDetails.iWard);
          // }
        } else {
          this.wardList = [];
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.wardList = [];
        this.toastService.showError(error.message);
      },
    });
  }
  getDropdownData() {
    this.societyService.getDropDownData().subscribe({
      next: (response) => {
        if (response.status === 200) {

          this.operationAreaList = response.data.operationArea;
          this.divisionList = response.data.division;
          this.societyKindList = response.data.societyKind;
          this.societyTypeList = response.data.societyType;

        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.toastService.showError(error.message);
      },
    });
  }
  onDistrictChange(event: any) {
    let iDistrictID: any = 0;
    if (event) {
      iDistrictID = Number((event.target as HTMLSelectElement).value);
    }
    this.getLocalBody(event);
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {

        if (response.status === 200) {
          this.circleList = response.lstCircle;
          // this.blockData = response.lstBlock
          this.subdivisionList = response.lstSubDivison;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
        // Handle any errors that occur during the request
        // this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  allowOnlyNumbers(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    // Handle typing
    if (event.type === 'keypress') {
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }

    // Handle paste
    if (event.type === 'paste') {
      const pastedInput: string = (event.clipboardData).getData('text');
      if (!/^\d+$/.test(pastedInput)) {
        event.preventDefault();
      }
    }
  }

}

